export default __webpack_public_path__ + "static/media/profileImg.fc6610a0.svg";